import request from '@/utils/request'


// 查询经销商套餐管理列表
export function listJoe(query) {
  return request({
    url: '/joe/dealer-menu/list',
    method: 'get',
    params: query
  })
}

// 查询经销商套餐管理分页
export function pageJoe(query) {
  return request({
    url: '/joe/dealer-menu/page',
    method: 'get',
    params: query
  })
}

// 查询经销商套餐管理详细
export function getJoe(data) {
  return request({
    url: '/joe/dealer-menu/detail',
    method: 'get',
    params: data
  })
}

// 新增经销商套餐管理
export function addJoe(data) {
  return request({
    url: '/joe/dealer-menu/add',
    method: 'post',
    data: data
  })
}

// 修改经销商套餐管理
export function updateJoe(data) {
  return request({
    url: '/joe/dealer-menu/edit',
    method: 'post',
    data: data
  })
}

// 删除经销商套餐管理
export function delJoe(data) {
  return request({
    url: '/joe/dealer-menu/delete',
    method: 'post',
    data: data
  })
}
